import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { SocketModel } from "@/models/SocketModel";
import router from "@/router";
import useEmitter from "@/composables/Emmiter";
import { io } from "socket.io-client";

const emitter = useEmitter();

@Module
export default class SocketModule extends VuexModule implements SocketModel {
  main: any;
  isNotificationGerenciar: any;
  session: any = sessionStorage.getItem("notification");
  notifications: any = this.session != "" ? JSON.parse(this.session) : [];
  /**
   * Get data dashboard
   * @returns a main socket
   */
  get mainSocket(): any {
    return this.main;
  }
  get isNotificationGerenciarSocket(): any {
    return this.isNotificationGerenciar;
  }

  get notificationsSession(): any {
    return this.notifications;
  }

  @Mutation
  [Mutations.START_SOCKET]() {
    console.log("iniciou");
    if (!this.main) {
      this.main = io("https://node-indicar.azurewebsites.net");
    }
  }

  @Action
  [Actions.NEW_LISTEN](options) {
    console.log("chamou action", options);
    this.main.on(options.name, (data) => options.callbackFunction(data));
  }

  @Mutation
  [Mutations.NOTIFICATION_IN_GERENCIAR]() {
    this.isNotificationGerenciar = this.isNotificationGerenciar ? false : true;
    console.log("action gerenciar notificacao", this.isNotificationGerenciar);
  }

  @Mutation
  [Mutations.SAVE_NEW_NOTIFICATION](notification) {
    this.notifications.push(notification);
    console.log("mutations", this.notifications);
  }

  @Action
  [Actions.REMOVE_LISTEN](options) {
    console.log("removeu action", options);
    this.main.removeListener(options.name);
  }

  @Action
  [Actions.DISCONNECT_SOCKET]() {
    if (this.main) {
      this.main.disconnect();
    }
  }
}
